import React, { useEffect, useState, useContext } from 'react';
import { HealthAssesment } from '../providers/health-assesment-provider';
import noUiSlider from 'nouislider';
import 'nouislider/distribute/nouislider.css';

export const MultiStepSlider = ({ onChange, idSlider, idValue, achValue, pcValue, ccValue, otherValue }) => {
  const [ isLoaded, setIsLoaded ] = useState(false);
  const { healthAssesmentData } = useContext(HealthAssesment);
  const firstValue = parseInt(achValue);
  const secondValue = firstValue + parseInt(pcValue);
  const thirdValue = secondValue + parseInt(ccValue);
  const fourthValue = thirdValue + parseInt(otherValue);

  useEffect(() => {
    const rangeSlider = document.getElementById(idSlider);

    if (!isLoaded) {
      noUiSlider.create(rangeSlider, {
        start: [firstValue, secondValue, thirdValue, fourthValue],
        step: 1,
        tooltips: [true, true, true, true],
        connect: ["upper", "upper", "upper", "upper", "upper"],
        range: {
            'min': [0],
            'max': [100]
        }
      });
      var tooltips = rangeSlider.noUiSlider.getTooltips();

      tooltips[0].innerHTML = 25 + " %";
      tooltips[1].innerHTML = 25 + " %";
      tooltips[2].innerHTML = 25 + " %";
      tooltips[3].innerHTML = 25 + " %";

      rangeSlider.noUiSlider.on('update', function (values, handle) {
        const currentValue =  parseInt(values[handle]);
        const lastValue =  parseInt(values[handle - 1]);
        const value = currentValue - lastValue;
        if (handle === 0) {
          onChange({ target: { name: "ach", value: currentValue }});
          tooltips[0].innerHTML = currentValue + " %";
        } else if (handle === 1) {
          onChange({ target: { name: "pc", value: value  }});
          tooltips[1].innerHTML = value + " %";
        } else if (handle === 2) {
          onChange({ target: { name: "cc", value: value }});
          tooltips[2].innerHTML = value + " %";
        } else if (handle === 3) {
          onChange({ target: { name: "other", value: value }});
          tooltips[3].innerHTML = value + " %";
        }
      });
      rangeSlider.noUiSlider.on('end', function (values, handle) {
        const ach = parseFloat(healthAssesmentData.arCosts.ach) || 0;
        const pc = parseFloat(healthAssesmentData.arCosts.pc) || 0;
        const cc = parseFloat(healthAssesmentData.arCosts.cc) || 0;
        const other = parseFloat(healthAssesmentData.arCosts.other) || 0;
        const sum = ach + pc + cc + other;
        const remaining = 100 - sum;
        if (handle === 3) {
          rangeSlider.noUiSlider.set([
            ach,
            ach + pc,
            ach + pc + cc + remaining,
            ach + pc + cc + other + remaining
          ])
        } else {
          rangeSlider.noUiSlider.set([
            ach,
            ach + pc,
            ach + pc + cc,
            ach + pc + cc + other + remaining
          ]);
        }
      });
      setIsLoaded(true)
    }
  }, [onChange, idSlider, idValue, isLoaded, firstValue, secondValue, thirdValue, fourthValue, healthAssesmentData.arCosts.ach, healthAssesmentData.arCosts.pc, healthAssesmentData.arCosts.cc, healthAssesmentData.arCosts.other])

  return (
    <div className="multi-range-slider">
      <div className="range">
        <div id={idSlider} className="slider-range" />
      </div>
    </div>
  )
}